export default {"src":"/flights/assets/desktop/_next/static/media/train.8db4fe5f.svg","height":16,"width":16};